import {Component, inject, signal} from '@angular/core';
import {MaterialModule} from '@app/material.module';
import { CommonModule } from '@angular/common';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {TablerIconsModule} from 'angular-tabler-icons';
import {catchError, EMPTY, filter, from, iif, map, switchMap, tap} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {
  ContentComponent,
  ExplorerService
} from 'filemanager-explorer';
import {SharedDataService} from '@core/services/share-data/share-data.service';
import { MatButtonModule } from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import { FilemanagerPinnableStateService } from '@app/core/services/filemanager-pinnable-state/filemanager-pinnable-state.service';
import { FilemanagerApiService } from '@app/core/services/api/filemanager/filemanager-api.service';
import { FileUser } from '@app/core/models/files';
import { ModalsSendFileComponent } from '@app/components/modals/modals-send-file/modals-send-file.component';
import { ModalsCutPdfComponent } from '@app/components/modals/modals-cut-pdf/modals-cut-pdf.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-filemanager-sidebar',
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    TablerIconsModule,
    ContentComponent,
    MatButtonModule,
    MatTooltipModule,
    ModalsSendFileComponent,
    ModalsCutPdfComponent,
  ],
  standalone: true,
  templateUrl: './filemanager-sidebar.component.html',
  styleUrl: './filemanager-sidebar.component.scss'
})
export class FilemanagerSidebarComponent {
  public _explorerService = inject(ExplorerService);
  protected openedDir$ = this._explorerService.openedDir$.pipe(map((p) => p?.data['name']));
  pinnedState$ = signal<boolean>(false);
 fileEdit$ = signal<FileUser | null>({}); 
  fileType$ = signal<'file' | 'pdf' | null>(null);
  constructor(
    private sharedDataService: SharedDataService,
    private filemanagerPinnableStateService: FilemanagerPinnableStateService,
    private fileManagerService: FilemanagerApiService
  ) {
    // this.explorerService.openTree({ id: 15, name: 'Aerosmith', path: '/Music/Rock/' });
    this._explorerService.openNode();
    // this._explorerService.openFile$.subscribe(f => {
    //   console.log('openFileSub', f)
    // })
    // this.pinnedState$.set(this.sharedDataService.getStoredData('modalpinned') || false);
  }
  ngOnInit() {

    this.filemanagerPinnableStateService.filemanagerPinnedState$.subscribe(state => {
      console.log('filemanager pinnedState', state)
      this.pinnedState$.set(state);
    });
  }

  ngOnDestroy(): void {
    this.openFileSub.unsubscribe();
  }

  togglePinned() {
    this.pinnedState$.set(!this.pinnedState$());
    this.filemanagerPinnableStateService.setState(this.pinnedState$());
  
  }

  protected openFileSub = this._explorerService.openFile$.pipe(
     tap((f)=> console.log('openFileSub', f)),
      filter(f => !!f?.isLeaf && !!f?.data['uuid'] && !!f?.data['name']),
      switchMap(f => {
        const uuid = f?.data['uuid'];
        const name = f?.data['name'];
    
        return iif(
          () => f?.data['content_type'] === "application/pdf",
          from(this.fileManagerService.cutPagePdfPromise(uuid, 1)).pipe(
            switchMap(() =>
              this.fileManagerService.getFileBytes(uuid).pipe(
                map(response => ({ data: response, name, uuid})),
                filter((res): res is { data: any; name: string; uuid: string } => !!res.data),
                tap(res => this.fileEdit$.update(() => res)),
                tap(() => this.fileType$.set('pdf')),
                catchError(error => {
                  console.error('Errore nel recupero file:', error);
                  return EMPTY;
                })
              )
            )
          ),
          this.fileManagerService.getFileBytes(uuid).pipe(
            map(response => ({ data: response, name, uuid })),
            filter((res): res is { data: any; name: string; uuid: string } => !!res.data),
            tap(res => this.fileEdit$.update(() => res)),
            tap(() => this.fileType$.set('file')),
            catchError(error => {
              console.error('Errore nel recupero file:', error);
              return EMPTY;
            })
          )
        );
      })
  ).subscribe();
  
  closeEditor(event: any) {
    console.log('closeEditor', event)
    if(!event){
      return;
    }
    this.fileType$.set(null);
    setTimeout(() => {  
      this.fileEdit$.set(null);
      this._explorerService.openFile(undefined);
    }, 100);
  }

}
